import PropTypes from 'prop-types'
import React, {useEffect, useState} from 'react'
import {ConfigProvider, theme as antdTheme} from 'antd'

/**
 * antd's own components (Button, Menu, Badge, Popover, Modal, ...) follow Flow's light/dark theme. The theme lives in
 * classes on <html> (utils/themeMode.js applyThemeClasses: every dark-family theme adds `dark-mode`), which only Flow's
 * own CSS reads; without this antd kept drawing its light tokens in dark mode (white default buttons, a white selected
 * sidebar item). The class is watched, so the account menu's Sun/Moon toggle switches antd at once too.
 */
const isDarkNow = () => document.documentElement.classList.contains('dark-mode')

export default function AntdThemeBridge({children}) {
  const [dark, setDark] = useState(isDarkNow)

  useEffect(() => {
    const observer = new MutationObserver(() => setDark(isDarkNow()))
    observer.observe(document.documentElement, {attributes: true, attributeFilter: ['class']})
    return () => observer.disconnect()
  }, [])

  return (
    <ConfigProvider theme={{algorithm: dark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm}}>
      {children}
    </ConfigProvider>
  )
}

AntdThemeBridge.propTypes = {
  children: PropTypes.node,
}
